import variant1 from "../../images/icons/headerIcons/variant1.svg";
import variant2 from "../../images/icons/headerIcons/variant2.svg";
import variant3 from "../../images/icons/headerIcons/variant3.svg";
import variant4 from "../../images/icons/headerIcons/variant4.svg";
import variant5 from "../../images/icons/headerIcons/variant5.svg";
import variant6 from "../../images/icons/headerIcons/variant6.svg";
import variant7 from "../../images/icons/headerIcons/variant7.svg";
import variant8 from "../../images/icons/headerIcons/variant8.svg";
import betino from "../../images/betino.png";
import wuxal from "../../images/wuxal.png";
import fertiplant from "../../images/fertiplant.png";
import uniferX from "../../images/uniferX.png";

export const companyObject = {
  items: [
    {
      images: [variant1],
      title: "About us",
    },
    {
      images: [variant8, variant2, variant7],
      title: "Research, news & events",
    },
    {
      images: [variant3],
      title: "Career",
    },
  ],
  button: "",
};

export const productsObject = {
  items: [
    {
      images: [betino],
      title: "Organic line",
    },
    {
      images: [wuxal],
      title: "Wuxal",
    },
    {
      images: [fertiplant],
      title: "Fertiplant",
    },
    {
      images: [uniferX],
      title: "UniferX",
    },
  ],
  button: "ALL PRODUCTS",
};

export const resourcesObject = {
  items: [
    {
      images: [variant4],
      title: "Crop nutrition programs",
    },
    {
      images: [variant5],
      title: "Trial results",
    },
    {
      images: [variant6],
      title: "Information materials",
    },
  ],
  button: "ALL RESOURCES",
};
